/**
 * Formats plan type codes for display in user-facing text
 * @param {string} planType - Raw plan type code (e.g., "403b", "457", "FICA")
 * @returns {string} Formatted plan type (e.g., "403(b)", "457", "FICA")
 */
const formatPlanType = (planType) => {
  if (!planType) return 'distribution';

  const typeMap = {
    '403b': '403(b)',
    '403bAdmin': '403(b) Admin',
    '401k': '401(k)',
    '457': '457',
    '457b': '457(b)',
    '457bAdmin': '457(b) Admin',
    'FICA': 'FICA',
    'FinPath403b': 'FinPath 403(b)',
    'FinPath457b': 'FinPath 457(b)',
    '403b9Church': '403(b)(9) Church Plan',
    'NQDC': 'Non-Qualified Deferred Compensation (NQDC)',
  };

  return typeMap[planType] || planType.toUpperCase();
};

export default formatPlanType;
